<template>
  <div class="canteen">
    <div class="canteen-content">
      <div class="canteen-list">
        <div class="title">食品经营许可证</div>
        <div class="cert-img">
          <el-image
            v-if="canteenData.foodTradePermit"
            :src="$store.state.config.fileUrl + canteenData.foodTradePermit"
            :preview-src-list="[
              $store.state.config.fileUrl + canteenData.foodTradePermit
            ]"
          >
          </el-image>
          <img
            v-else
            src="@/assets/img/foodSafety/yingyezhizhao-shili.png"
            alt=""
          />
        </div>
      </div>

      <div class="canteen-list">
        <div class="title">安全等级评估</div>
        <div class="canteen-rate">
          <div class="rate-content">
            <div class="last-rate">
              <div class="last-rate-tip">
                <div class="first">
                  <span v-if="canteenData.lastYearComprehensiveGrade == 0"
                    >A</span
                  >
                  <span v-if="canteenData.lastYearComprehensiveGrade == 1"
                    >B</span
                  >
                  <span v-if="canteenData.lastYearComprehensiveGrade == 2"
                    >C</span
                  >
                </div>
                <div class="last">上年度综合等级</div>
              </div>
              <div class="last-rate-tip">
                <img
                  src="@/assets/img/foodSafety/icon_perfect_big.png"
                  alt=""
                  v-if="canteenData.lastYearComprehensiveGrade == 0"
                />
                <img
                  src="@/assets/img/foodSafety/icon_good_big.png"
                  alt=""
                  v-if="canteenData.lastYearComprehensiveGrade == 1"
                />
                <img
                  src="@/assets/img/foodSafety/icon_soso_big.png"
                  alt=""
                  v-if="canteenData.lastYearComprehensiveGrade == 2"
                />
                <div class="last">本次检查动态等级</div>
              </div>
            </div>
            <div class="rate-info">
              <div class="rate-info-tip">
                <img
                  src="@/assets/img/foodSafety/icon_perfect_big.png"
                  alt=""
                />
                <div>A 优秀</div>
              </div>
              <div class="rate-info-tip">
                <img src="@/assets/img/foodSafety/icon_good_big.png" alt="" />
                <div>B 良好</div>
              </div>
              <div class="rate-info-tip">
                <img src="@/assets/img/foodSafety/icon_soso_big.png" alt="" />
                <div>C 一般</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="canteen-list">
        <div class="title">员工信息</div>
        <div class="canteen-staff">
          <div class="block" v-if="newArray.length > 0">
            <el-carousel
              trigger="click"
              width="420px"
              height="197px"
              indicator-position="none"
              :autoplay="isAutoplay"
            >
              <el-carousel-item
                class="staff-list"
                v-for="(item, index) in newArray"
                :key="index"
              >
                <div
                  class="staff-info"
                  v-for="(staff, index) in item"
                  :key="index"
                  @click="seeMore(staff)"
                >
                  <div class="staff-img">
                    <img
                      :src="
                        $store.state.config.fileUrl + staff.healthCertificate
                      "
                      alt=""
                    />
                  </div>
                  <div class="staff-content">
                    <div class="satff-name">
                      <div>姓名：{{ staff.diningStaffName }}</div>
                      <div>
                        性别：{{ staff.diningStaffSex == 0 ? "男" : "女" }}
                      </div>
                    </div>
                    <div class="staff-phone">
                      电话：{{ staff.diningStaffPhone }}
                    </div>
                    <div class="staff-status">
                      证件状态：
                      <span class="status-0" v-if="staff.staffStatus == 0"
                        >未过期</span
                      >
                      <span class="status-1" v-if="staff.staffStatus == 1"
                        >30天后过期</span
                      >
                      <span class="status-2" v-if="staff.staffStatus == 2"
                        >已过期</span
                      >
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="no-staff" v-else>暂无数据</div>
        </div>
      </div>

      <div class="canteen-list">
        <div class="title">证件过期提醒</div>
        <div class="canteen-tip" v-if="staffList.length > 0">
          <template v-for="(item, index) in staffList">
            <div class="tip-list" v-if="item.staffStatus != 0" :key="index">
              <div class="tip-info">
                食堂员工{{ item.diningStaffName }}的健康证件{{
                  item.staffStatus == 0
                    ? "未过期"
                    : item.staffStatus == 1
                    ? "30天后过期"
                    : "已过期"
                }},请及时处理!
              </div>
              <div class="tip-look" @click="seeMore(item)">立即查看</div>
            </div>
          </template>
        </div>
        <div class="canteen-tip">
          <div class="tip-none">暂无数据</div>
        </div>
      </div>
    </div>
    <!-- 证件过期提醒弹窗 -->
    <div class="tip-dialog" v-if="istipDialogShow">
      <div class="mask"></div>
      <div class="tip-content">
        <div class="tip-close" @click="istipDialogShow = false">X</div>
        <div class="tip-content-content">
          <div class="content-title">
            <div class="title-name"></div>
          </div>
          <div class="content-content">
            <div class="info-img">
              <img
                :src="
                  $store.state.config.fileUrl + tipInfo.healthCertificate
                "
                alt=""
              />
            </div>
            <div class="info-list">
              <div class="info-li">
                <div>姓名：</div>
                <div>{{ tipInfo.diningStaffName }}</div>
              </div>
              <div class="info-li">
                <div>性别：</div>
                <div>{{ tipInfo.diningStaffSex == 0 ? "男" : "女" }}</div>
              </div>
              <div class="info-li">
                <div>电话：</div>
                <div>{{ tipInfo.diningStaffPhone }}</div>
              </div>
              <div class="info-li">
                <div>过期时间：</div>
                <div>
                  {{ $Common.dateFormatDate(tipInfo.healthCertificateDateEnd) }}
                </div>
              </div>
              <div class="info-li">
                <div>状态：</div>
                <div v-if="tipInfo.staffStatus == 0" style="color:#fffff">
                  未过期
                </div>
                <div v-if="tipInfo.staffStatus == 1" style="color:#ffea3d">
                  30天后过期
                </div>
                <div v-if="tipInfo.staffStatus == 2" style="color:#ff0000">
                  已过期
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "foodSafetyKitchen",
  components: {},
  props: {
    canteenData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      staffList: [],
      newArray: [],
      isAutoplay: true,
      tipInfo: {},
      istipDialogShow: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    canteenData: function(newVal) {
      this.getHealthCertificate();
    }
  },
  methods: {
    // 健康证展示
    async getHealthCertificate() {
      if (!this.canteenData.id) {
        return;
      }
      let requestData = {
        diningRoomId: this.canteenData.id
        // schoolId:parseInt(this.$store.state.schoolId)
      };
      // console.log(requestData);
      let res = await this.$Http.getHealthCertificate(requestData, true);
      if (res.code == 200) {
        // console.log(res.data)
        this.staffList = res.data;
        this.modify();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 修改返回视频数组结构
    modify() {
      let newArray = [];
      if (this.staffList.length > 0) {
        let staffList = this.staffList;
        // this.schoolName = this.eduSchoolInfo.list[0].schoolName;
        let start = 0;
        let end = 2;
        let length = staffList.length;
        let times = parseInt(length / 2);
        if (times * 2 <= length) {
          times++;
        }
        for (var i = 0; i < times; i++) {
          let sliceArray = staffList.slice(start, end);
          start = end;
          end = end + 2;
          if (sliceArray.length > 0) {
            newArray.push(sliceArray);
          }
        }
      }
      this.newArray = newArray;

      // console.log(newArray);
    },
    seeMore(item) {
      // console.log(item)
      this.istipDialogShow = true;
      this.tipInfo = item;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.canteen {
  .canteen-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    div {
      width: 360px;
      height: 36px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #dbe1ff;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }
  .canteen-content {
    height: 760px;
    overflow-y: scroll;
  }
  .canteen-list {
    margin-bottom: 16px;
    .title {
      padding-left: 18px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ced6ff;
      line-height: 28px;
      letter-spacing: 1px;
      margin-bottom: 8px;
      position: relative;
      &:before {
        content: "";
        border-left: 2px solid #9cacff;
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 6px;
      }
    }
    .cert-img {
      width: 370px;
      height: 245px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 1px 31px 0px #3cccfb inset;
      border-radius: 1px;
      position: relative;
      padding: 10px;
    }
    .canteen-rate {
      width: 370px;
      height: 150px;
      box-shadow: 0px 0px 25px 0px #2db6d0 inset;
      border-radius: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 10px;
      .rate-content {
        width: 100%;
        height: 100%;
        background: rgba(33, 45, 118, 0.49);
        border-radius: 1px;
        border: 2px solid #2c97c0;
      }
      .last-rate {
        height: 50%;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .last-rate-tip {
        flex: 0 0 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        &:last-child {
          &:after {
            display: none;
          }
        }
        &:after {
          content: "";
          width: 2px;
          height: 40px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            #2c97c0 43%,
            rgba(255, 255, 255, 0) 100%
          );
          opacity: 0.5;
          position: absolute;
          top: 6px;
          right: -1px;
        }
        .first {
          text-align: center;
          span {
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #b3e088;
            line-height: 33px;
            letter-spacing: 1px;
          }
        }
        .last {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #dbe1ff;
          line-height: 17px;
        }
        img {
          width: 28px;
          height: 28px;
          margin-bottom: 2px;
        }
      }
      .rate-info {
        height: 50%;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .rate-info-tip {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }
        div {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #acda80;
          line-height: 17px;
        }
      }
    }
    .canteen-staff {
      .staff-list {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .staff-info {
        width: 183px;
        height: 197px;
        box-shadow: 0px 1px 31px 0px #3cccfb inset;
        border-radius: 1px;
        padding: 5px;
        margin-right: 16px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .staff-img {
        width: 173px;
        height: 116px;
        img {
          width: 173px;
          height: 116px;
        }
      }
      .staff-content {
        padding: 4px 12px;
      }
      .satff-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #dbe1ff;
          line-height: 17px;
        }
      }
      .staff-phone {
        margin-top: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #dbe1ff;
        line-height: 17px;
      }
      .staff-status {
        margin-top: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #dbe1ff;
        line-height: 17px;
        span {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 17px;
          &.status-0 {
            color: #ffffff;
          }
          &.status-1 {
            color: #ffea3d;
          }
          &.status-2 {
            color: #ff0000;
          }
        }
      }
      .no-staff {
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
      }
    }
    .canteen-tip {
      position: relative;
      left: 20px;
      .tip-list {
        margin-bottom: 10px;
        position: relative;
      }
      .tip-info {
        display: flex;
        align-items: center;
        width: 400px;
        height: 36px;
        padding-left: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #ced6ff;
        background: url("~@/assets/img/foodSafety/big-data-school-safe-kitcken-staff-out-bg.png")
          center center no-repeat;
      }
      .tip-look {
        font-size: 14px;
        font-weight: 400;
        color: #ced6ff;
        cursor: pointer;
        position: absolute;
        right: 34px;
        top: 7px;
        &:hover {
          color: #ffffff;
        }
      }
      .tip-none {
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        position: relative;
        left: -20px;
      }
    }
  }
}
.tip-dialog {
  width: 886px;
  height: 440px;
  padding: 25px 45px 30px 32px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -500px;
  margin-top: -300px;
  z-index: 11;
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #00000080;
    z-index: 3;
  }
  .tip-close {
    padding: 18px 24px;
    cursor: pointer;
    position: absolute;
    font-size: 20px;
    top: 0px;
    right: 0px;
    color: #ffffff;
    z-index: 5;
  }
  .tip-content {
    width: 886px;
    height: 440px;
    padding: 25px 45px 30px 32px;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -446px;
    margin-top: -300px;
    background: url("~@/assets/img/foodSafety/big-data-school-safe-kitchen-dialog-bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    position: relative;
    z-index: 4;
    .tip-content-content {
      .content-title {
        display: flex;
        justify-content: center;
        align-items: center;
        .title-name {
          width: 80px;
          height: 20px;
          background: url("~@/assets/img/foodSafety/big-data-school-safe-kitchen-dialog-title.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .content-content {
      height: 370px;
      display: flex;
      justify-content: center;
      align-items: center;
      .info-img {
        width: 380px;
        height: 232px;
        margin-right: 43px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info-list {
        width: 410px;
        position: relative;
        top: 16px;
        .info-li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 40px;
          position: relative;
          &:after {
            content: "";
            width: 386px;
            height: 4px;
            background: url("~@/assets/img/foodSafety/big-data-school-safe-kitchen-dialog-line.png")
              center center no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 4px;
            bottom: -10px;
          }
          div {
            &:first-child {
              flex: 0 0 96px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 25px;
              letter-spacing: 1px;
              text-align: right;
            }
            &:last-child {
              flex: 0 0 200px;
              padding-right: 60px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #a8dfff;
              line-height: 25px;
              letter-spacing: 1px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>
